import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=10c90f4f"
import script from "./newIndex.vue?vue&type=script&lang=js"
export * from "./newIndex.vue?vue&type=script&lang=js"
import style0 from "./newIndex.vue?vue&type=style&index=0&id=10c90f4f&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c90f4f')) {
      api.createRecord('10c90f4f', component.options)
    } else {
      api.reload('10c90f4f', component.options)
    }
    module.hot.accept("./newIndex.vue?vue&type=template&id=10c90f4f", function () {
      api.rerender('10c90f4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/customerInvoiceSubjectConfiguration/newIndex.vue"
export default component.exports